/**
 * Fela custom properties
 * https://github.com/robinweser/fela/tree/master/packages/fela-plugin-custom-property
 */

import { ctaFiligree } from "~/styleguide/filigree";

const stripPx = string => {
    if (typeof string == "string") {
        return parseInt(string.replace("px", ""));
    } else {
        return parseInt(string);
    }
};

export default {
    // One liners for setting margin/padding
    filigree: secondaryColor => ({
        position: "relative",
        overflow: "hidden",
        ":before": {
            content: "''",
            width: "16%",
            maxWidth: "160px",
            height: "100%",
            left: "0",
            top: 0,
            bottom: 0,
            margin: "auto",
            backgroundImage: 'url("' + ctaFiligree(secondaryColor) + '")',
            backgroundSize: "92%",
            backgroundPosition: "right center",
            position: "absolute",
            zIndex: 0,
            maxWidthTablet: {
                backgroundSize: "88%"
            }
        },
        ":after": {
            content: "''",
            width: "16%",
            maxWidth: "160px",
            height: "100%",
            right: "0",
            top: 0,
            bottom: 0,
            margin: "auto",
            backgroundImage: 'url("' + ctaFiligree(secondaryColor) + '")',
            backgroundSize: "92%",
            backgroundPosition: "left center",
            position: "absolute",
            zIndex: 0,
            maxWidthTablet: {
                backgroundSize: "88%"
            }
        },
        minWidthTabletLandscape: {
            ":before": {
                left: "0"
            },
            ":after": {
                right: "0"
            }
        }
    }),
    paddingV: value => ({
        paddingTop: value,
        paddingBottom: value
    }),
    paddingH: value => ({
        paddingLeft: value,
        paddingRight: value
    }),
    marginV: value => ({
        marginTop: value,
        marginBottom: value
    }),
    marginH: value => ({
        marginLeft: value,
        marginRight: value
    }),

    /**
     * Used for hover/active states
     */
    whenActive: value => ({
        ":active": value,
        ":hover": value
    }),
    after: value => ({
        ":after": {
            content: value,
            display: "inline-block"
        },
        ":last-of-type": {
            ":after": {
                content: "none"
            }
        }
    }),
    decorativeCircle: ({
        circleWidth = 360,
        multiplyer = 1,
        margin = 170,
        opacity = 1,
        direction = "right",
        extend = {}
    }) => {
        const marginCalc = stripPx(margin) * stripPx(multiplyer);
        const widthCalc = stripPx(circleWidth) * stripPx(multiplyer);

        return {
            ...extend,
            [direction]: `calc(${marginCalc}px + ${widthCalc}px)`,
            opacity: opacity
        };
    },
    grid: ({
        cols,
        margins,
        border = "0",
        bottomMargin = margins,
        length = "0",
        lastElem = "0px"
    }) => {
        let lastColItem = `:nth-child(${stripPx(cols)}n)`;
        let lastRow = `:nth-last-child(-n+${stripPx(cols)})`;

        length = stripPx(length);
        cols = stripPx(cols);

        if (length > 0 && length - cols < cols) {
            if (length > cols) {
                let lastAmount = length - cols;
                lastRow = `:nth-last-child(-n+${lastAmount})`;
            } else {
                lastRow = `:nth-last-child(-n+${length})`;
            }
        } else {
            if (cols == 2 && length % 2) {
                lastRow = `:nth-last-child`;
            }
        }

        return {
            width: `calc(100% /  ${stripPx(cols)}  - ${stripPx(
                border
            )}px -  ${stripPx(margins) + 1}px * ( ${stripPx(
                cols
            )}  - 1) /  ${stripPx(cols)} )`,
            marginRight: margins,
            marginBottom: bottomMargin,
            [lastColItem]: {
                marginRight: 0
            },
            [lastRow]: {
                marginBottom: 0
            },
            ":last-of-type": {
                marginRight: lastElem
            }
        };
    }
};
